/* rb-m-home.js -- category chip row, rail "see all" links, footer rebuild.
   Phone only. Depends on window.RBM from rb-m-core.js.
   Also defines RBM.categories() for rb-m-nav.js, which loads after this. */
(function () {
  'use strict';
  if (!window.RBM) return;

  /* ---- category source ----------------------------------------------------
     Matched on the collection HANDLE in the href, never on link text. The
     mega-menu labels carry their child counts ("Shirts6 options"), so text
     matching silently found nothing on the first build. Handles are also the
     only reliable mapping: the menu label "Outerwear" points at
     /collections/jackets on this store. */
  var CATS = [
    { handle: 'new',         label: 'New' },
    { handle: 'shirts',      label: 'Shirts' },
    { handle: 'bottoms',     label: 'Bottoms' },
    { handle: 'jackets',     label: 'Outerwear' },
    { handle: 'footwear',    label: 'Footwear' },
    { handle: 'accessories', label: 'Accessories' },
    { handle: 'sale',        label: 'Sale' }
  ];
  /* Sale used to carry accent:true, which filled its chip on the homepage and
     its tile in the drawer dark -- a "selected" look with nothing selected
     (Mark, 15 Sep). The accent plumbing stays so a campaign can turn it back
     on for a real reason; nothing is flagged by default. */

  RBM.categories = function () {
    var byHandle = {};
    Array.prototype.forEach.call(document.querySelectorAll('a[href*="/collections/"]'), function (a) {
      var m = (a.getAttribute('href') || '').match(/\/collections\/([a-z0-9\-]+)\/?(?:[?#]|$)/i);
      if (m && !byHandle[m[1].toLowerCase()]) byHandle[m[1].toLowerCase()] = true;
    });
    var out = [];
    CATS.forEach(function (c) {
      if (byHandle[c.handle]) out.push({ label: c.label, href: '/collections/' + c.handle, accent: c.accent });
    });
    return out;
  };

  /* ---- infinite loop OFF on phones ------------------------------------------
     Both carousels sit inside <items-scroll infinite-loop="true">, which
     appends a clone of every item and, once you scroll into the clones,
     silently resets scrollLeft to the matching real item to fake a loop.

     Measured on the category row at 393px: scroll to the end and it ran to
     1422 then jumped to 575. The reset position is computed from the item
     width the theme expects, and the phone pass changes that width, so
     instead of an invisible wrap it reads as the row snapping back to the
     start. (The product rails already looked right only because their clones
     were hidden, which starved the same code of anything to jump to.)

     A five-tile row does not need an infinite loop. Turning it off is both
     halves of the fix: drop the attribute so nothing resets the scroll, and
     drop the clones so the row ends on the last real category. Doing it in
     JS rather than CSS keeps the loop and its clones in one place -- the
     clones only exist because of the behaviour being removed here.
     Verified after: rests at 574 and stays there, 5 tiles, no jump. */
  RBM.onMobile('loop-off', function () {
    Array.prototype.forEach.call(
      document.querySelectorAll('items-scroll[infinite-loop]'), function (s) {
        s.removeAttribute('infinite-loop');
        Array.prototype.forEach.call(s.querySelectorAll('.is-loop-clone'), function (clone) {
          clone.style.display = 'none';
        });
      });
  });

  /* ---- shop collections grid (Mark, 22 Sep) ----------------------------------
     Replaces the category chip row under the hero AND the theme's 2-up
     collection carousel (JEANS / TRUNKS ...) below the bus. One block, eight
     tiles, two across, in the carousel's slot: every top-level way into the
     catalogue in one screen, no sideways scroll. Tiles are 5:4 so the block
     is ~300px -- the carousel it replaces was 280.

     Images are the collections' own banner images (or a product hero where a
     collection has none); handles are the same set the drawer uses. The
     theme's carousel section is hidden, not removed. */
  var GRID = [
    /* New + Bottoms images: Mark picked from the store's own collection
       banners (23 Sep) so they match the other tiles' lifestyle photography
       -- Taylor Stitch banner (man on the dunes) and Ace Rivington banner
       (stacked denim). */
    { handle: 'new',         label: 'New',         img: 'https://cdn.shopify.com/s/files/1/0643/2024/1896/collections/Taylor_Stitch_collection_Banner.png?v=1775674301&width=400' },
    { handle: 'shirts',      label: 'Shirts',      img: 'https://cdn.shopify.com/s/files/1/0643/2024/1896/collections/rooster_resized_1919x768_0b59364c-8543-44a1-89f2-d6cf37266e80.jpg?v=1778716609&width=400' },
    { handle: 'bottoms',     label: 'Bottoms',     img: 'https://cdn.shopify.com/s/files/1/0643/2024/1896/collections/ace_banner_pohotos.png?v=1775597534&width=400' },
    { handle: 'jackets',     label: 'Outerwear',   img: 'https://cdn.shopify.com/s/files/1/0643/2024/1896/collections/jackets.jpg?v=1702591493&width=400' },
    { handle: 'hats',        label: 'Hats',        img: 'https://cdn.shopify.com/s/files/1/0643/2024/1896/collections/landing_hero_seager.jpg?v=1775674959&width=400' },
    { handle: 'footwear',    label: 'Footwear',    img: 'https://cdn.shopify.com/s/files/1/0643/2024/1896/collections/Hari-Will-Leather-Goods_1_Shoes.png?v=1681507808&width=400' },
    { handle: 'accessories', label: 'Accessories', img: 'https://cdn.shopify.com/s/files/1/0643/2024/1896/collections/accessories-rec.jpg?v=1681509328&width=400' },
    { handle: 'sale',        label: 'Sale',        img: 'https://cdn.shopify.com/s/files/1/0643/2024/1896/files/the-isle-17-5-boardshort-07.jpg?v=1782935871&width=400' }
  ];

  /* ---- Sale tile: a seasonal on-sale product, changes daily (Mark, 23 Sep) --
     Mark's call: the Sale tile does not have to match the lifestyle tiles;
     it should show "whatever flat would fit the season" from what is
     actually on sale. So: fetch the sale collection once, keep products that
     are in stock, really marked down (compare_at > price) and in a seasonal
     type list (Sep-Feb: flannels/jackets/denim/pants; Mar-Aug: shorts/swim/
     tees/SS wovens), and pick one by day-of-year so every visitor sees the
     same product on a given day and it rolls over at midnight. The static
     image stays until the fetch lands, then the src swaps -- no blank tile,
     no flash. The list is cached in sessionStorage for the session. Anything
     missing or failing leaves the static image in place. */
  /* Tops only, no pants/denim: the tile crops the image to fill (like the
     boardshort did), and a tall pant shot cropped to 8:5 is a pair of legs;
     shown whole it is a tiny jean (Mark hated it). Shirts, jackets and
     shorts fill the frame. */
  var SEASON = {
    cold: /jacket|flannel|long sleeve|ls woven|hoodie|crewneck|sweater|sweatshirt|quarter zip|vest|shacket|overshirt|fleece/i,
    warm: /short|swim|trunk|boardshort|ss woven|short sleeve|tee|t-shirt|polo|tank|camp/i
  };
  function seasonOf(d) { var m = d.getMonth(); return (m >= 8 || m <= 1) ? 'cold' : 'warm'; }   /* Sep-Feb cold */
  function saleTile(img) {
    if (!img || !window.fetch) return;
    var today = new Date();
    var key = 'rbm-sale-' + today.getFullYear() + '-' + today.getMonth() + '-' + today.getDate();
    function apply(list) {
      if (!list || !list.length) return;
      var start = new Date(today.getFullYear(), 0, 0);
      var doy = Math.floor((today - start) / 864e5);
      var p = list[doy % list.length];
      var src = p.src.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2');
      var pre = new Image();
      pre.onload = function () { img.src = src; img.alt = p.title; };
      pre.src = src;
    }
    try { var c = sessionStorage.getItem(key); if (c) { apply(JSON.parse(c)); return; } } catch (e) {}
    var season = SEASON[seasonOf(today)];
    fetch('/collections/sale/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        var list = (j.products || []).filter(function (p) {
          var hay = (p.product_type || '') + ' ' + (p.title || '');
          if (!season.test(hay)) return false;
          if (!p.images || !p.images.length) return false;
          return (p.variants || []).some(function (v) {
            return v.available && v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price);
          });
        }).map(function (p) { return { title: p.title, src: p.images[0].src }; });
        try { sessionStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
        apply(list);
      })
      .catch(function () {});
  }

  RBM.onMobile('home-collgrid', function () {
    var slot = document.querySelector('main#main > .js-section__collections-list');
    if (!slot || document.querySelector('.rbm-collgrid')) return;
    var sec = document.createElement('section');
    sec.className = 'rbm-collgrid shopify-section';
    sec.innerHTML = '<h2 class="rbm-collgrid__title">Shop collections</h2>';
    var grid = document.createElement('div');
    grid.className = 'rbm-collgrid__grid';
    GRID.forEach(function (c) {
      var a = document.createElement('a');
      a.className = 'rbm-collgrid__tile';
      a.href = '/collections/' + c.handle;
      a.innerHTML = '<img loading="lazy" alt="" src="' + c.img + '"><b>' + c.label + '</b>';
      grid.appendChild(a);
    });
    sec.appendChild(grid);
    slot.parentNode.insertBefore(sec, slot);
    slot.classList.add('rbm-replaced');
    saleTile(grid.querySelector('a[href="/collections/sale"] img'));
  });

  /* ---- featured brands (Mark, 22 Sep) -----------------------------------------
     A dark band after the collections grid: a row of brand tiles (text for
     now -- logos to follow), the chosen brand's name and "Shop all", and a
     2-up rail of that brand's products fetched from the storefront's own
     /collections/<handle>/products.json. Nothing is rendered server-side, so
     the section costs one small JSON request per brand viewed, and only on
     phones. Rails are cached per brand for the page's life. */
  /* The eight, picked by Mark 23 Sep from 180-day order counts plus mix
     (two surf, denim, house brand, caps, leather, premium): see changelog.
     Logos are theme assets rb-m-logo-<handle>.<ext>, white on transparent,
     pulled from each brand's own site (Palma lifted from the Rooster banner). */
  var BRANDS = [
    { handle: 'katin',              label: 'Katin',              logo: 'svg' },
    { handle: 'seager',             label: 'Seager',             logo: 'png' },
    { handle: 'ace-rivington',      label: 'Ace Rivington',      logo: 'png' },
    { handle: 'palma',              label: 'Palma',              logo: 'png' },
    { handle: 'american-needle',    label: 'American Needle',    logo: 'svg' },
    { handle: 'will-leather-goods', label: 'Will Leather Goods', logo: 'png' },
    { handle: 'roark',              label: 'Roark',              logo: 'svg' },
    { handle: 'faherty',            label: 'Faherty',            logo: 'svg' }
  ];
  /* asset URL from the core script's own src: same CDN folder, no version
     hash needed (Shopify serves the current file without ?v=) */
  var LOGO_V = '3';   /* BUMP THIS whenever a logo file is replaced -- the CDN caches the unversioned URL */
  var ASSET_BASE = (function () {
    var s = document.querySelector('script[src*="rb-m-core.js"]');
    return s ? s.src.replace(/rb-m-core\.js.*$/, '') : '';
  })();

  RBM.onMobile('home-brands', function () {
    var after = document.querySelector('.rbm-collgrid') || document.querySelector('main#main > .js-section__collections-list');
    if (!after || document.querySelector('.rbm-brands')) return;

    var sec = document.createElement('section');
    sec.className = 'rbm-brands shopify-section';
    sec.innerHTML =
      '<div class="rbm-brands__head"><h2>Featured brands</h2><a href="/pages/brands">All brands</a></div>' +
      '<div class="rbm-brands__tiles rbm-hs" role="tablist"></div>' +
      '<div class="rbm-brands__sel"><b class="rbm-brands__name"></b><a class="rbm-brands__shop">Shop all &rarr;</a></div>' +
      '<div class="rbm-brands__caret"></div>' +
      '<div class="rbm-brands__rail rbm-hs" aria-live="polite"></div>' +
      '<div class="rbm-brands__wrap"><a class="rbm-brands__all"></a></div>';
    var tiles = sec.querySelector('.rbm-brands__tiles');
    var name = sec.querySelector('.rbm-brands__name');
    var shop = sec.querySelector('.rbm-brands__shop');
    var rail = sec.querySelector('.rbm-brands__rail');
    var all = sec.querySelector('.rbm-brands__all');
    var cache = {};

    function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
    function card(p) {
      var img = (p.images && p.images[0] && p.images[0].src) || '';
      if (img) img = img.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2');
      var v = p.variants || [];
      var prices = v.map(function (x) { return parseFloat(x.price); }).filter(function (n) { return !isNaN(n); });
      var min = prices.length ? Math.min.apply(null, prices) : NaN;
      var price = isNaN(min) ? '' : (prices.length > 1 && Math.max.apply(null, prices) !== min ? 'from ' : '') + money(Math.round(min * 100));
      return '<div class="rbm-brands__card js-product-card" data-ga4-item-name="' + escAttr(p.title) + '" data-ga4-price="' + (isNaN(min) ? '' : min) + '">' +
        '<a class="rbm-brands__link" href="/products/' + p.handle + '">' +
        '<span class="rbm-brands__img">' + (img ? '<img loading="lazy" alt="" src="' + img + '">' : '') + '</span>' +
        '<span class="rbm-brands__pn">' + (p.title || '') + '</span>' +
        '<span class="rbm-brands__pp">' + price + '</span></a>' + quickAdd(p) + '</div>';
    }

    /* ---- quick add on brand cards (Mark, 29 Sep) ------------------------------
       The theme's mobile size sheet (assets/rb-quick-add-sheet.js) opens for any
       .js-product-card whose .js-quick-add-mobile-trigger is tapped, and reads
       everything it needs from markup: .js-quick-add-overlay (colour/size option
       positions + current colour), the .js-quick-add-variants map
       [id, color, size, available, finalSale, compareAt, price] and the card's
       own form.js-product-form. So each brand card gets the SAME hidden block a
       grid card renders in snippets/product-grid-item.liquid -- built here from
       /products.json instead of Liquid -- and the theme does the rest: sizes in
       order, "sold out - notify me", final-sale properties, add through
       ajaxCart (drawer + count), GA4. Forms are wired with ajaxCart.initForm()
       every time the rail is (re)painted. Colour = the variant in the card's
       photo, else the first available (same rule as a grid card with no swatch
       picked). Skipped for sold-out products and fit parents (no sizes of
       their own; the card links to their wash picker). */
    function escAttr(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function quickAdd(p) {
      var v = p.variants || [];
      if (!v.some(function (x) { return x.available; })) return '';
      if ((p.tags || []).indexOf('combined-listing-parent') >= 0) return '';
      if ((p.tags || []).indexOf('in-store-only') >= 0) return ''; // in-store only (e.g. Vuori): no mobile quick add
      var opts = (p.options || []).map(function (o) { return String(o.name || o).trim().toLowerCase(); });
      var cPos = opts.indexOf('color'), sPos = opts.indexOf('size');
      var photoId = p.images && p.images[0] && p.images[0].id;
      var cur = v.filter(function (x) { return x.available && x.featured_image && x.featured_image.id === photoId; })[0] ||
                v.filter(function (x) { return x.available; })[0];
      var color = cPos >= 0 ? (cur['option' + (cPos + 1)] || '') : '';
      var cents = function (s) { return s == null || s === '' ? null : Math.round(parseFloat(s) * 100); };
      var map = v.map(function (x) {
        var price = cents(x.price), cap = cents(x.compare_at_price);
        return [x.id, cPos >= 0 ? x['option' + (cPos + 1)] : '', sPos >= 0 ? x['option' + (sPos + 1)] : '',
          x.available ? 1 : 0, cap && cap > price ? 1 : 0, cap, price];
      });
      var label = (sPos >= 0 ? 'Choose a size for ' : 'Quick add ') + escAttr(p.title);
      return '<div class="quick-add-overlay js-quick-add-overlay rbm-brands__qa" data-product-id="' + p.id + '" data-color-position="' + cPos + '" data-size-position="' + sPos + '" data-current-color="' + escAttr(color) + '">' +
          '<form action="/cart/add" method="post" enctype="multipart/form-data" class="js-product-form quick-add-overlay__form" data-product-id="' + p.id + '">' +
            '<input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">' +
            '<input type="hidden" name="id" value="' + cur.id + '" class="js-quick-add-id"><input type="hidden" name="quantity" value="1">' +
            '<input type="submit" name="add" tabindex="-1" aria-hidden="true" class="js-product-add quick-add-overlay__hidden-submit" style="position:absolute;width:1px;height:1px;padding:0;margin:-1px;border:0;clip:rect(0 0 0 0);overflow:hidden;">' +
            '<script type="application/json" class="js-quick-add-variants">' + JSON.stringify(map).replace(/</g, '\\u003c') + '<\/script>' +
          '</form></div>' +
        '<button type="button" class="quick-add-overlay__mobile-trigger js-quick-add-mobile-trigger rbm-brands__add" aria-label="' + label + '">' +
          /* same wrapper as the grid's button: the theme styles the glyph as an
             outline (fill:none) only inside .quick-add-overlay__trigger-open */
          '<span class="quick-add-overlay__trigger-open" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M6.5 8.5h11l1 11h-13l1-11Z"></path><path d="M9 9V7a3 3 0 0 1 6 0v2"></path><path d="M12 12v4M10 14h4"></path></svg></span>' +
        '</button>';
    }
    function wireForms() {
      if (!window.ajaxCart || !window.ajaxCart.initForm) return;
      Array.prototype.forEach.call(rail.querySelectorAll('form.js-product-form'), function (f) {
        if (f.dataset.rbmAjax) return;
        f.dataset.rbmAjax = '1';
        window.ajaxCart.initForm(f);
      });
    }
    function show(b) {
      name.textContent = b.label;
      shop.href = '/collections/' + b.handle;
      all.href = '/collections/' + b.handle;
      all.textContent = 'Shop all ' + b.label;
      Array.prototype.forEach.call(tiles.children, function (t) {
        var on = t.getAttribute('data-handle') === b.handle;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (cache[b.handle]) { rail.innerHTML = cache[b.handle]; wireForms(); return; }
      rail.innerHTML = '<span class="rbm-brands__card rbm-brands__card--ph"></span><span class="rbm-brands__card rbm-brands__card--ph"></span>';
      fetch('/collections/' + b.handle + '/products.json?limit=8')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) {
          var html = (j.products || []).filter(function (p) { return p.images && p.images.length; }).slice(0, 8).map(card).join('');
          cache[b.handle] = html;
          if (name.textContent === b.label) { rail.innerHTML = html; wireForms(); }
        })
        .catch(function () { rail.innerHTML = ''; });
    }
    BRANDS.forEach(function (b, i) {
      var t = document.createElement('button');
      t.type = 'button';
      t.className = 'rbm-brands__tile';
      t.setAttribute('role', 'tab');
      t.setAttribute('data-handle', b.handle);
      t.setAttribute('aria-label', b.label);
      if (b.logo && ASSET_BASE) {
        var im = document.createElement('img');
        im.alt = ''; im.loading = 'lazy'; im.decoding = 'async';
        im.src = ASSET_BASE + 'rb-m-logo-' + b.handle + '.' + b.logo + '?v=' + LOGO_V;
        im.addEventListener('error', function () { t.textContent = b.label; });   /* text if the asset is missing */
        t.appendChild(im);
      } else {
        t.textContent = b.label;
      }
      t.addEventListener('click', function () { show(b); });
      tiles.appendChild(t);
    });
    after.parentNode.insertBefore(sec, after.nextSibling);
    show(BRANDS[0]);
  });

  /* ---- rails: "see all" link + per-panel button ----------------------------
     The rail shows 12 of a collection, so every rail needs a way through to
     the rest of it. There is no existing link other than the promo banner's,
     which is hidden on phones -- so borrow its href.

     EVERY TAB PANEL GETS ITS OWN BUTTON. "Current Rotation" is two panels
     (Just Landed -> /collections/new, Headwear -> /collections/hats), each
     with its own promo link and its own product track. The first build asked
     the SECTION for one promo link and appended one button, so Headwear had
     no way out of it at all. Sections with no tabs (Summer Essentials) are
     handled by falling back to the section itself as the single scope. */
  function railButton(scope) {
    var promo = scope.querySelector('.featured-collections__promo-link');
    var href = promo && promo.getAttribute('href');
    /* A block with no promo image (the Sale tab, 22 Sep) has no promo link;
       fall back to the tab button that controls this panel. */
    var label = promo ? (promo.textContent || 'See all') : '';
    if (!href && scope.id) {
      var tab = document.getElementById(scope.getAttribute('aria-labelledby') || '');
      if (tab && tab.getAttribute('data-update-link')) { href = tab.getAttribute('data-update-link'); label = 'Shop ' + (tab.textContent || '').trim(); }
    }
    if (!href) return null;
    var track = scope.querySelector('.featured-collections-fixed-layout__products') ||
                scope.querySelector('.featured-collections-fixed-layout');
    if (track && !scope.querySelector('.rbm-seeall-btn')) {
      var btn = document.createElement('a');
      btn.className = 'rbm-seeall-btn';
      btn.href = href;
      /* The promo link's label is merchandiser-written ("Shop new", "Shop
         Hats"), so use it verbatim rather than bolting "See all" onto the
         front and producing "See all shop new". CSS capitalises it. */
      btn.textContent = label.trim().replace(/\s+/g, ' ');
      track.appendChild(btn);
    }
    return href;
  }

  RBM.onMobile('rail-seeall', function () {
    Array.prototype.forEach.call(
      document.querySelectorAll('.section--featured-collections'), function (sec) {
        if (sec.dataset.rbmSeeall === '1') return;

        var panels = sec.querySelectorAll('tab-panel, [role="tabpanel"]');
        var scopes = panels.length ? panels : [sec];
        var first = null;
        Array.prototype.forEach.call(scopes, function (s) {
          var h = railButton(s);
          if (h && !first) first = h;
        });
        if (!first) return;

        /* The heading link is one per section, so on a tabbed rail it has to
           follow the active tab -- otherwise "See all" on Headwear walks you
           to New Arrivals. The tab buttons carry data-update-link. */
        var title = sec.querySelector('.section__title');
        if (title && !title.querySelector('.rbm-seeall')) {
          var a = document.createElement('a');
          a.className = 'rbm-seeall';
          a.href = first;
          a.innerHTML = 'See all <span aria-hidden="true">&rarr;</span>';
          title.appendChild(a);

          var tabs = sec.querySelectorAll('tab-triggers button');
          Array.prototype.forEach.call(tabs, function (t) {
            t.addEventListener('click', function () {
              var h = t.getAttribute('data-update-link');
              if (h) a.href = h;
            });
          });
        }
        sec.dataset.rbmSeeall = '1';
      });
  });

  /* ---- seasonal rail subtitle (option B, 22 Sep) ----------------------------------
     One line under "Shop the Summer essentials". Copy lives here until the
     section grows a setting for it. */
  RBM.onMobile('summer-sub', function () {
    var sec = document.querySelector('main#main > .shopify-section[id$="new_arrivals_carousel_KTNkYy"]');
    var title = sec && sec.querySelector('.section__title');
    if (!title || sec.querySelector('.rbm-rail-sub')) return;
    var p = document.createElement('p');
    p.className = 'rbm-rail-sub';
    p.textContent = 'Light layers and easy fits for the hot months.';
    title.parentNode.insertBefore(p, title.nextSibling);
  });

  /* ---- image grid tile: a real button ---------------------------------------
     The B&W bus is a link (a.home-image-grid__link -> /pages/about-us) with
     nothing on it that says so -- on a phone a full-bleed photograph reads as
     a banner, not a tap target. The category tiles get their button back from
     CSS (the theme ships one); this tile has no button in the markup at all,
     so it gets one here, in the same pill style. */
  RBM.onMobile('tile-btn', function () {
    var link = document.querySelector('.js-section__home-image-grid .home-image-grid__link');
    if (!link || link.querySelector('.rbm-tile-btn')) return;
    var head = link.querySelector('h1, h2, h3, .home-image-grid__heading');
    var label = head && head.textContent.trim() ? head.textContent.trim().replace(/\s+/g, ' ') : 'Our story';
    if (label.length > 22) label = 'Our story';
    var box = link.querySelector('.home-image-grid__item--image') || link;
    var btn = document.createElement('span');
    btn.className = 'rbm-tile-btn';
    btn.textContent = label;
    box.appendChild(btn);
  });

  /* ---- footer ---------------------------------------------------------------
     Accordions are gone. Instead: the three support links people actually hunt
     for get lifted to the top as full-width rows, and everything else stays in
     its existing group, open, two columns.

     The three lifted links are REMOVED from their original list so nothing
     appears twice. Everything is read from the DOM, so hrefs cannot drift. */
  /* Short labels on purpose: these are three buttons across a 393px screen,
     not three rows. Full-width rows with chevrons (first build) spent 156px
     on three links and still read as filler. */
  var ESSENTIALS = [
    { match: '/pages/contact',   label: 'Contact' },
    { match: '/pages/returns',   label: 'Returns' },
    { match: '/pages/locations', label: 'Stores' }
  ];

  RBM.onMobile('footer-rebuild', function () {
    var grid = document.querySelector('.rb-footer__grid');
    if (!grid || grid.dataset.rbmFooter === '1') return;

    /* 1. find and lift the essentials */
    var picked = [];
    ESSENTIALS.forEach(function (e) {
      var link = grid.querySelector('a[href*="' + e.match + '"]');
      if (!link) return;
      picked.push({ href: link.getAttribute('href'), label: e.label });
      var li = link.closest('li');
      if (li) li.parentNode.removeChild(li);
    });

    if (picked.length) {
      var box = document.createElement('nav');
      box.className = 'rbm-foot-key';
      box.setAttribute('aria-label', 'Help and stores');
      picked.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'rbm-foot-key__row';
        a.href = p.href;
        a.textContent = p.label;
        box.appendChild(a);
      });
      grid.parentNode.insertBefore(box, grid);
    }

    /* 2. lists stay open and go two-up. Any heading hidden by the earlier
          accordion build is restored, and its button removed. */
    Array.prototype.forEach.call(grid.children, function (col) {
      var btn = col.querySelector('.rb-footer__acc-btn');
      if (btn) btn.parentNode.removeChild(btn);
      var list = col.querySelector('ul');
      if (!list) return;
      var n = list.previousElementSibling;
      while (n) { if (n.style && n.style.display === 'none') n.style.display = ''; n = n.previousElementSibling; }
      list.classList.add('rbm-foot-list');
      /* A column emptied by the lift (Help keeps FAQ/Rewards/Careers, so this
         only fires if the theme's menu changes) should not leave a heading. */
      if (!list.querySelector('li')) col.style.display = 'none';
    });

    grid.dataset.rbmFooter = '1';
  });
})();
